import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { AnimatePresence, motion } from 'framer-motion'

import styles from './Toast.module.scss'

interface ToastProps {
  isVisible: boolean

  type?: 'not_enough_stars' | 'limit_is_full' | 'withdraw'
}

const Toast: React.FC<ToastProps> = ({ isVisible, type = 'not_enough_stars' }) => {
  const { t } = useTranslation()

  const [isActive, setIsActive] = useState<boolean>(isVisible)

  useEffect(() => {
    setIsActive(isVisible)
    const timer = setTimeout(() => {
      setIsActive(false)
    }, 2500)
    return () => clearTimeout(timer)
  }, [isVisible])

  return (
    <AnimatePresence>
      {isActive && (
        <motion.div
          className={styles.block}
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{
            duration: 0.3,
            ease: 'easeInOut',
          }}
        >
          {t(`${type}.title`)}
        </motion.div>
      )}
    </AnimatePresence>
  )
}

export default Toast
